/**
 * @file     articleGrid.ts
 * @purpose  Column template for the article body. The table-of-contents rail is
 *           reserved only when it actually renders: RSS commentary posts carry a
 *           single block and no headings, so reserving the rail for them left
 *           220px of dead space beside a needlessly narrow article. One helper
 *           so the reservation and the rail cannot drift apart.
 */

/** Width of the sticky table-of-contents rail at lg and up. */
export const TOC_RAIL_WIDTH = '220px';

export function articleGridColumns(showToc: boolean) {
  return {
    xs: 'minmax(0, 1fr)',
    lg: showToc ? `minmax(0, 1fr) ${TOC_RAIL_WIDTH}` : 'minmax(0, 1fr)',
  };
}

export function articleGridGap(showToc: boolean) {
  return { xs: '32px', lg: showToc ? '56px' : '32px' };
}

/** One heading is not a table of contents; it is a subhead. */
export function shouldShowToc(headingCount: number): boolean {
  return headingCount > 1;
}
